import script from "./ModalBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBase.vue?vue&type=script&setup=true&lang=js"

import "./ModalBase.vue?vue&type=style&index=0&id=cd421986&lang=css"

const __exports__ = script;

export default __exports__